import {gql} from "graphql-request";

export const GetRegion = gql`
  query GetRegion($id:ID!) {
    region(id: $id){
      name
      impressionsCount
      reviewsCount
      lonlatCoords
      polygon {
        id
        boundingPolygon
      }
    }
  }
`;
